import { CardContent, CircularProgress, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  close,
  getAccidents,
  getReasonsClousure,
} from "../../../../actions/accidents";
import snackbarUtils from "../../../../utils/snackbarUtils";
import ConfirmDialog from "../../../commons/dialog/confirmDialog";
import CustomDialog from "../../../commons/dialog/customDialog";
import FormikForm from "../../../commons/formik/formikForm";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextFieldSpeech from "../../../commons/formik/formikTextFieldSpeech";
import { StyledCloseAccident } from "../../../styled/accident";

const validationSchema = Yup.object({
  idMotivoCierre: Yup.number()
    .integer("Identificador inválido")
    .required("Campo obligatorio")
    .min(0, "Identificador inválido"),
  observaciones: Yup.string().max(200, "Puede ingresar hasta 200 caracteres"),
});

const CloseAccident = ({ accident, open, handleClose, invalid }) => {
  const dispatch = useDispatch();
  const reasonsClousure = useSelector(
    (state) => state.accidents.reasonsClousure,
  );
  const closeAccident = useSelector((state) => state.accidents.closeAccident);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [values, setValues] = useState("");

  const closeConfirm = () => {
    setOpenConfirmDialog(false);
  };

  const openConfirm = () => {
    setOpenConfirmDialog(true);
  };

  const submitConfirm = () => {
    if (values) {
      dispatch(close(accident, values)).then(() => {
        dispatch(getAccidents());
        handleClose();
        closeConfirm();
        snackbarUtils.success("Siniestro cerrado exitosamente");
      });
    }
  };

  const initialValues = {
    idMotivoCierre: "",
    observaciones: "",
  };

  useEffect(() => {
    accident && dispatch(getReasonsClousure(accident));
  }, [accident]);

  return (
    <CustomDialog open={open} onClose={handleClose}>
      <StyledCloseAccident.Title>Cerrar Siniestro</StyledCloseAccident.Title>
      <StyledCloseAccident.ContentContainer>
        {reasonsClousure.isFetching ? (
          <CircularProgress size={40} />
        ) : (
          <CardContent>
            <FormikForm
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                if (values) {
                  setValues(values);
                  openConfirm();
                }
              }}>
              <StyledCloseAccident.FormContainer>

                <FormikSelect
                  name="idMotivoCierre"
                  label="Motivo del cierre"
                  variant="standard"
                  value={initialValues.idMotivoCierre}>
                  {reasonsClousure.data.length &&
                    reasonsClousure.data.map((rc) => (
                      <MenuItem value={rc.id} key={rc.id}>
                        {rc.descripcion}
                      </MenuItem>
                    ))}
                </FormikSelect>

                <FormikTextFieldSpeech
                  sx={{ mt: 2 }}
                  name="observaciones"
                  multiline
                  variant="outlined"
                  label="Observaciones"
                />
                <StyledCloseAccident.ButtonContainer>
                  <StyledCloseAccident.StyledButton
                    onClick={handleClose}
                    color="primary">
                    Cancelar
                  </StyledCloseAccident.StyledButton>
                  <StyledCloseAccident.CloseAccidentButton
                    variant="contained"
                    type="submit"
                    disabled={invalid}>
                    Cerrar Siniestro
                  </StyledCloseAccident.CloseAccidentButton>
                </StyledCloseAccident.ButtonContainer>
              </StyledCloseAccident.FormContainer>
            </FormikForm>
          </CardContent>
        )}
      </StyledCloseAccident.ContentContainer>
      <ConfirmDialog
        open={openConfirmDialog}
        title={"¿Está seguro que desea cerrar el Siniestro?"}
        handleClose={closeConfirm}
        handleConfirm={submitConfirm}
        loading={closeAccident.isFetching}
      />
    </CustomDialog>
  );
};

export default CloseAccident;
